<template>
  <a-layout class="h-100">
    <a-layout-header class="bg-white border-b">
      <h3 style="font-weight: 500">{{ $t('resources.title') }}</h3>
    </a-layout-header>
    <a-layout class="h-100">
      <a-layout-sider class="h-100 bg-white border-r">
        <a-tree
          :treeData="category"
          :default-expand-all="true"
          :replaceFields="{children: 'children', title: 'text', key:'value' }"
          @select="changeCategory"
        >
          <template #title="{ value: treeKey, text }">
            <a-dropdown :trigger="['contextmenu']">
              <span>{{ text }}</span>
              <!-- <template #overlay>
                <a-menu style="width: 100px" @click="({ key }) => showCategoryModal(key, treeKey, name)">
                  <a-menu-item key="1" v-if="treeKey === 0 && authorities.find(a => a.code === 'device:manage:device:group:resource:insert')">新增</a-menu-item>
                  <template v-else>
                    <a-menu-item key="2">修改</a-menu-item>
                   <a-menu-item key="3">删除</a-menu-item>
                  </template>
                </a-menu>
              </template> -->
            </a-dropdown>
          </template>
        </a-tree>
        <a-modal :title="categoryModal.title" v-model="categoryModal.visible" @ok="saveCategory">
          <a-form-model>
            <a-form-model-item :label="$t('linkage.name')">
              <a-input v-model="categoryModal.name" />
            </a-form-model-item>
          </a-form-model>
        </a-modal>
      </a-layout-sider>
      <a-layout-content class="bg-white" style="height: 860px; overflow: auto">
        <a-space style="padding: 10px 15px">
          <a-button v-if="authorities.find(a => a.code === 'device:manage:device:group:resource:insert')" type="primary" @click="visible = true; form.category=currentCategoryId" :disabled="currentCategoryId === '0-0' || currentCategoryId === undefined"><a-icon type="upload" />{{ $t('resources.upload') }}</a-button>
        </a-space>
        <a-table
          :row-key="record => record.id"
          :columns="resourceColumns"
          :data-source="resourceList"
          :row-selection="resourceSelection"
          :pagination="pagination"
          @change="handleTableChange"
        >
          <template v-slot:name="text, record">
            <a :href="record.url" target="_blank">{{ text }}</a>
          </template>
          <template v-slot:createdAt="text, record">
            {{ moment(record.createdAt).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template v-slot:updatedAt="text, record">
            {{ moment(record.updatedAt).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template v-slot:operation="text, record">
            <a-button v-if="authorities.find(a => a.code === 'device:manage:device:group:resource:update')" style="padding: 0; margin-right: 15px" type="link" @click="editResource(record)">{{ $t('buttons.edit') }}</a-button>
            <a-popconfirm
              v-if="authorities.find(a => a.code === 'device:manage:device:group:resource:delete')"
              :title="$t('messages.ctrd')"
              :ok-text="$t('common.okText')"
              :cancel-text="$t('common.cancelText')"
              @confirm="removeResource(record)"
            >
              <a href="#">{{ $t('buttons.delete') }}</a>
            </a-popconfirm>
          </template>
        </a-table>
        <a-drawer :title="$t('buttons.edit')" :closable="false" width="40%" :visible="resourceDrawer.visible" :body-style="{ padding: 0, height: '100%' }" @close="onCloseDrawer">
          <a-layout>
            <a-layout-content class="h-100 bg-white" style="padding: 20px">
              <a-form-model>
                <a-form-model-item :label="$t('resources.code')">
                  <a-input v-model="resourceDrawer.record.id" disabled />
                </a-form-model-item>
                <a-form-model-item :label="$t('resources.category')">
                  <a-select v-model="resourceDrawer.record.category">
                    <a-select-option :key="item.id" v-for="item in this.category[0].children" :value="item.value">
                      {{ item.text }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item :label="$t('linkage.name')">
                  <a-input v-model="resourceDrawer.record['zh-CN']" />
                </a-form-model-item>
                <a-form-model-item :label="$t('resources.url')">
                  <a-textarea v-model="resourceDrawer.record.url" disabled />
                </a-form-model-item>
                <a-form-model-item :label="$t('resources.uploadTime')">
                  <a-input :value="moment(resourceDrawer.record.createdAt).format('YYYY-MM-DD HH:mm:ss')" disabled />
                </a-form-model-item>
                <a-form-model-item :label="$t('common.updatedAt')">
                  <a-input :value="moment(resourceDrawer.record.updatedAt).format('YYYY-MM-DD HH:mm:ss')" disabled />
                </a-form-model-item>
              </a-form-model>
              <a-divider />
              <div>
                <img class="w-100" :src="resourceDrawer.record.url">
              </div>
            </a-layout-content>
            <a-layout-footer style="position: absolute;bottom: 0;right: 0" class="bg-white border-t border-b" :style="{ padding: '12px 24px' }">
              <a-space style="float: right">
                <a-button type="primary" @click="saveResource">{{ $t('buttons.save') }}</a-button>
                <a-button @click="resourceDrawer.visible = false">{{ $t('common.cancelText') }}</a-button>
              </a-space>
            </a-layout-footer>
          </a-layout>
        </a-drawer>
      </a-layout-content>
    </a-layout>
    <a-modal v-model="visible" :title="$t('buttons.uploadPic')" @ok="upload">
      <a-form-model ref="ruleForm" :model="form" :rules="rules">
        <a-form-model-item :label="$t('linkage.name')" prop="name">
          <a-input v-model="form.name" autocomplete="off" />
        </a-form-model-item>
       <a-form-model-item :label="$t('resources.category')" prop="category">
          <a-select v-model="form.category">
            <a-select-option :key="item.id" v-for="item in this.category[0].children" :value="item.value">
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-upload
            :before-upload="beforeUpload"
            :showUploadList="false"
          >
            <a-button type="primary" @click="visible = true" :disabled="currentCategoryId === '0-0' || currentCategoryId === undefined"><a-icon type="upload" />{{ $t('resources.upload') }}</a-button>
          </a-upload>
          <div v-show="file" class="ant-upload-list ant-upload-list-text"><div class=""><span><div class="ant-upload-list-item ant-upload-list-item-undefined ant-upload-list-item-list-type-text"><div class="ant-upload-list-item-info"><span><i aria-label="图标: paper-clip" class="anticon anticon-paper-clip"><svg viewBox="64 64 896 896" data-icon="paper-clip" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 0 0 174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"></path></svg></i><span title="c5e0271a35335f816a7bfc20818b15f6c21d6bf93598d82d1386c00ac7a0a83e.png" class="ant-upload-list-item-name">{{name}}</span><span class="ant-upload-list-item-card-actions "><a :title="$t('resources.deleteFile')" @click="file=null"><i aria-label="图标: delete" tabindex="-1" class="anticon anticon-delete" :title="$t('resources.deleteFile')"><svg viewBox="64 64 896 896" data-icon="delete" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"></path></svg></i></a></span></span></div><!----></div></span></div></div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-layout>
</template>

<script>
import moment from 'moment'
import { resourceColumns } from './data'
import { resourceApi } from '@/api/station'
import resourceType from './resourceType.json'
import { getResourceTypeList, deleteSource, addSource, uploadSource } from '@/api/device'
import { getDict } from '@/api/dict'

export default {
  name: 'index',
  created() {
    const a = JSON.parse(sessionStorage.getItem('authorities'))
    if (a?.length) {
      this.authorities = a
    } else {
      this.authorities = this.getAuthorities(this.$route.path)
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    }
  },
  mounted () {
    getResourceTypeList(this.pagination.current, this.pagination.pageSize, this.queryParams).then(({ data }) => {
      this.resourceList = data.records.map(r => {
        r.details.forEach(d => {
          r[d.locale] = d.name
        })
        console.log(r);
        r.url = r.url.startsWith('https') ? r.url : ('https://ygk.nbdeman.com:9000' + r.url)
        return r
      })
      this.pagination.pageSize = data.size
      this.pagination.current = data.current
      this.pagination.total = data.total
    })
    // resourceApi.listCategory().then(({ data }) => {
    //   this.category[0].children = data
    //   return resourceApi.list()
    // }).then(({ data }) => {
    //   this.resourceList = data
    // }).catch(() => {
    //   // this.$message.error("请求失败")
    // })
  },
  data () {
    return {
      authorities: JSON.parse(sessionStorage.getItem('authorities')),
      resourceColumns,
      resourceSelection: {
        selectedRowKeys: [],
        onChange: (selectedRowKeys, selectedRows) => {
          this.resourceSelection.selectedRowKeys = selectedRowKeys
        }
      },
      visible: false,
      form: {
        image: null,
        name: '',
        category: ''
      },
      rules: {
        image: [
          {
            required: true,
            message: '请上传图片'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入名字'
          }
        ],
        category: [
          {
            required: true,
            message: '请选择资源目录'
          }
        ]
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      category: [
        {
          id: 0,
          name: '资源分类',
          children: []
        }
      ],
      queryParams: {
        query: [],
        filter: [],
        sort: [
          {
            field: "updatedAt",
            value: "DESC"
          }
        ]
      },
      currentCategoryId: undefined,
      resourceList: [
        {
          id: 1,
          name: 'test',
          categoryId: 2,
          url: 'http://10.55.43.249:9000/sr-test/23035efdf561a407f0f771cee2c7a009b5831b3f4a9832d19dfcd946cee262c4.jpg',
          createdAt: 1655449863251,
          updatedAt: 1655449863251
        }
      ],
      resourceDrawer: {
        visible: false,
        record: {}
      },
      categoryModal: {
        title: '',
        visible: false,
        id: 0,
        name: ''
      },
      file: null,
      imageUrl: null,
      fileList: [],
      name: ''
    }
  },
  methods: {
    moment,
    translate() {
      const lang = this.lang === 'en' ? 'en-US' : 'zh-CN'
      getDict(lang, 'stationResourceCategory').then(({ data }) => {
        this.category[0].children = []
        this.category[0].text = this.$t('resources.resourceCategary')
        data.content.forEach(i => {
          if (i.locale === lang) {
            this.category[0].children.push(i)
          }
        })
        console.log(this.category);
      })
    },
    editResource (record) {
      record.details.forEach(r => {
        record[r.locale] = r.name
      })
      this.resourceDrawer.record = record
      this.resourceDrawer.visible = true
    },
    onCloseDrawer () {
      this.resourceDrawer.visible = false
    },
    showCategoryModal (key, treeKey, name) {
      console.log(key, treeKey, name);
      switch (key) {
        case '1':
          this.categoryModal.title = '新增'
          this.categoryModal.id = 0
          this.categoryModal.name = ''
          break
        case '2':
          this.categoryModal.title = '修改'
          this.categoryModal.id = treeKey
          this.categoryModal.name = name
          break
        case '3':
          this.$Mconfirm({
            content: '是否删除该分类及其下属所有资源',
            okText: '确认删除',
            okType: 'danger',
            cancelText: '取消',
            onOk () {
              console.log('OK')
            },
            onCancel () {
              console.log('Cancel')
            }
          })
          return
      }
      this.categoryModal.visible = true
    },
    saveCategory () {
      console.log(this.resourceDrawer.record);
      // resourceApi.saveCategory(this.categoryModal.id, this.categoryModal.name).then(({ message }) => {
      //   this.$message.success(message)
      // }).then(() => {
      //   return resourceApi.listCategory()
      // }).then(({ data }) => {
      //   this.category[0].children = data
      //   this.categoryModal.visible = false
      // }).catch(() => {
      //   // this.$message.error("请求失败")
      // })
    },
    beforeUpload (file) {
      this.file = file
      this.name = file.name
      return true
    },
    upload () {
      // resourceApi.upload(this.currentCategoryId, this.file).then(({ message }) => {
      //   this.$message.success(message)
      //   return resourceApi.list(this.currentCategoryId)
      // }).then(({ data }) => {
      //   this.resourceList = data
      // }).catch(() => {
      //   // this.$message.error("请求失败")
      // }).finally(() => {
      //   this.file = null
      // })
      if (!this.file) {
        return this.$message.warn('请上传图片')
      }
      this.form.image = this.file
      this.$refs.ruleForm.validate(valid => {
        if(valid) {
          addSource(this.form).then(({ message }) => {
            this.$message.success(message)
            return getResourceTypeList(this.pagination.current, this.pagination.pageSize, this.queryParams)
          }).then(({ data }) => {
            this.visible = false
            this.resourceList = data.records.map(r => {
              r.details.forEach(d => {
                r[d.locale] = d.name
                r.url = r.url.startsWith('https') ? r.url : ('https://ygk.nbdeman.com:9000' + r.url)
              })
              return r
            })
            this.pagination.pageSize = data.size
            this.pagination.current = data.current
            this.pagination.total = data.total
          }).finally(() => {
            this.form = {
              image: null,
              name: '',
              category: ''
            }
            this.name = ''
            this.file = null
          })
        }
      })
    },
    changeCategory (selectedKeys) {
      this.currentCategoryId = selectedKeys[0]
      console.log(this.currentCategoryId)
      if (this.currentCategoryId === '0-0' || this.currentCategoryId === undefined) {
        this.queryParams.filter = []
      } else {
        this.queryParams.filter[0] = {
          field: 'category',
          value: this.currentCategoryId
        }
      }
      this.pagination.current = 1
      getResourceTypeList(this.pagination.current, this.pagination.pageSize, this.queryParams).then(({ data }) => {
        this.resourceList = data.records.map(r => {
          r.details.forEach(d => {
            r[d.locale] = d.name
            r.url = r.url.startsWith('https') ? r.url : ('https://ygk.nbdeman.com:9000' + r.url)
          })
          return r
        })
        this.pagination.pageSize = data.size
        this.pagination.current = data.current
        this.pagination.total = data.total
      })
      // resourceApi.list(this.currentCategoryId === undefined ? 0 : this.currentCategoryId).then(({ data }) => {
      //   this.resourceList = data
      // }).catch(() => {
      //   // this.$message.error("请求失败")
      // })
    },
    handleTableChange(pagination) {
      this.pagination = pagination
      getResourceTypeList(this.pagination.current, this.pagination.pageSize, this.queryParams).then(({ data }) => {
        this.resourceList = data.records.map(r => {
          r.details.forEach(d => {
            r[d.locale] = d.name
            r.url = r.url.startsWith('https') ? r.url : ('https://ygk.nbdeman.com:9000' + r.url)
          })
          return r
        })
        this.pagination.pageSize = data.size
        this.pagination.current = data.current
        this.pagination.total = data.total
      })
    },
    saveResource () {
      console.log(this.resourceDrawer.record);
      const r = { ...this.resourceDrawer.record, url: '/' + this.resourceDrawer.record.url.split('/').splice(3).join('/') }
      const z = r.details.find(i => i.locale === 'zh-CN')
      if (z) {
        z.name = r['zh-CN']
      } else {
        r.details[0] = [
          {
            locale: 'zh-CN',
            description: null,
            name: r['zh-CN'],
            resourceId: r.details[0].resourceId
          }
        ]
      }
      uploadSource(r).then(({ message }) => {
        this.$message.success(message)
        return getResourceTypeList(this.pagination.current, this.pagination.pageSize, this.queryParams)
      }).then(({ data }) => {
        this.resourceList = data.records.map(r => {
          r.details.forEach(d => {
            r[d.locale] = d.name
            r.url = r.url.startsWith('https') ? r.url : ('https://ygk.nbdeman.com:9000' + r.url)
          })
          return r
        })
        this.pagination.pageSize = data.size
        this.pagination.current = data.current
        this.pagination.total = data.total
      }).catch((e) => {
        console.log(e);
        // this.$message.error("请求失败")
      }).finally(() => {
        this.resourceDrawer.visible = false
      })
    },
    removeResource (record) {
      console.log(record);
      deleteSource(record.id).then(({ message }) => {
        this.$message.success(message)
        getResourceTypeList(this.pagination.current, this.pagination.pageSize, this.queryParams).then(({ data }) => {
          this.resourceList = data.records.map(r => {
            r.details.forEach(d => {
              r[d.locale] = d.name
              r.url = r.url.startsWith('https') ? r.url : ('https://ygk.nbdeman.com:9000' + r.url)
            })
            return r
          })
          this.pagination.pageSize = data.size
          this.pagination.current = data.current
          this.pagination.total = data.total
        })
      })
    //   resourceApi.remove(this.resourceSelection.selectedRowKeys).then(({ message }) => {
    //     this.$message.success(message)
    //   }).catch(() => {
    //     // this.$message.error("请求失败")
    //   }).finally(() => {
    //     resourceApi.list(this.currentCategoryId === undefined ? 0 : this.currentCategoryId).then(({ data }) => {
    //       this.resourceList = data
    //     })
    //   })
    }
  }
}
</script>

<style scoped>

</style>
